import axios from 'axios';
import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Typography } from '@mui/material';
import DLTAutocomplete from '@shared/components/form/DLTAutocomplete';
import DLTTextField from '@shared/components/form/DLTTextField';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { LoadingButton } from '@mui/lab';
const formSchema = yup.object({
    vasp_id: yup.string().required(),
    vasp_name: yup.string().when(['vasp_id'], (value, schema) => {
        if (value[0] === 'other') {
            return schema.required();
        }
        else {
            return schema;
        }
    }),
});
const SelectVASP = (props) => {
    const [isCustomVasp, setIsCustomVasp] = useState(false);
    const [vasps, setVasps] = useState([]);
    const { control, watch, handleSubmit, formState, setValue } = useForm({
        resolver: yupResolver(formSchema),
    });
    const vaspValue = watch('vasp_id');
    useEffect(() => {
        axios.get('/available-vasps', { baseURL: '/' })
            .then((response) => {
            var _a;
            const vasps = ((_a = response.data) === null || _a === void 0 ? void 0 : _a.vasps) || [];
            setVasps(vasps.map((v) => ({
                value: v.did,
                label: v.name,
            })));
        });
    }, []);
    useEffect(() => {
        if (vaspValue === 'other') {
            setIsCustomVasp(true);
        }
        else {
            setIsCustomVasp(false);
            setValue('vasp_name', undefined);
        }
    }, [vaspValue]);
    return (React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 2 } },
        React.createElement(Typography, { variant: 'subtitle2', fontWeight: 'bold' }, "Select VASP"),
        React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 2 } },
            React.createElement(Typography, { variant: 'caption' }, "Please select the VASP where the deposit came from:"),
            React.createElement(DLTAutocomplete, { name: 'vasp_id', label: 'VASP Name', control: control, options: [{ value: 'other', label: 'Other' }, ...vasps] }),
            isCustomVasp ? React.createElement(DLTTextField, { control: control, name: 'vasp_name', label: 'VASP Name' }) : null),
        React.createElement(LoadingButton, { loading: props.loading, disabled: !formState.isValid, variant: 'contained', onClick: handleSubmit(props.onNext) }, "Submit"),
        React.createElement(Button, { variant: 'outlined', onClick: () => {
                props.onBack();
            } }, "Back")));
};
export default SelectVASP;
